import { useInfiniteQuery } from "react-query";
import { useDispatch } from "react-redux";

import { getDefaultValuesForPaymentMethodForm } from "components/pages/paymentMethods/paymentMethodForm/getDefaultValuesForPaymentMethodForm";
import { getErrorMessage } from "helpers";
import { paymentMethodsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";
import { PaymentTypesType } from "types/enums/paymentTypes";

type useGetPaymentMethodsListQueryProps = {
	applicationId?: string;
	agentId?: number | string;
	merchantId?: number | string;
	paymentType?: PaymentTypesType;
	paymentMethodChosenId?: string;
	paymentMethodKey: string;
};

const useGetPaymentMethodsListQuery = ({
	applicationId,
	agentId,
	merchantId,
	paymentMethodChosenId,
	paymentType,
	paymentMethodKey,
}: useGetPaymentMethodsListQueryProps) => {
	const dispatch = useDispatch();

	const queryResult = useInfiniteQuery(
		[
			paymentMethodKey,
			applicationId,
			agentId,
			merchantId,
			paymentType,
			paymentMethodChosenId,
		],
		({ pageParam = 0 }) => {
			return paymentMethodsService.getPaymentMethodsList({
				applicationId,
				paymentType,
				agentId,
				merchantId,
				paymentMethodChosenId,
				page: pageParam,
			});
		},
		{
			select: data => {
				return {
					pages: data?.pages?.map(page => {
						const mappedData = {
							...page,
							items: page?.items?.map(item =>
								getDefaultValuesForPaymentMethodForm(
									item,
									"MM",
								),
							),
						};

						return mappedData;
					}),
					pageParams: data.pageParams,
				};
			},
			getNextPageParam: (lastPage, pages) => {
				const nextPage = pages.length;
				const count = Math.ceil(lastPage?.count / 5);
				return nextPage < count ? nextPage : undefined;
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			cacheTime: 0,
		},
	);

	return queryResult;
};

export default useGetPaymentMethodsListQuery;
